export default __webpack_public_path__ + "static/media/globe-no.cc1473d3.svg";